import React, { useRef, useState } from 'react'
import { Button, IconUserAddPlus, IconCloseOutlined, IconCheckCircle } from '@tutorbot/ui-components'
import { userInvitationDialog, Alert } from '../UI/Modal/ModalContent'
import { Form, Modal } from 'antd'
import { userInvites } from '../../services/api/ums/user'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import { setUsersListLastUpdatedAt } from '../../store/actions'
import styles from './AddNewUser.module.css'

const AddNewUser = () => {
  const inputField = useRef('')
  const [form] = Form.useForm()
  const [emailAddress, setEmailAddress] = useState({})
  const dispatch = useDispatch()

  const onSubmit = (values) => {
    userInvites(values)
      .then((res) => {
        console.log(res)
        const icon = <IconCheckCircle size={'sm'} fill={'var(--success-color)'} />
        const title = 'Invite sent'
        const content = <p>Invite has been successfully sent.</p>

        Alert(title, content, icon, handleOk)
      })
      .catch((error) => {
        const errorMessage = error.response.data.message[0].messages[0].message
        const icon = <IconCloseOutlined size={'sm'} fill={'var(--error-color)'} />
        const title = 'Error'
        const content = <p className={styles.error_text}>{errorMessage}</p>

        Alert(title, content, icon, handleOk)
      })
      .finally(
        () => dispatch(
          setUsersListLastUpdatedAt(moment().valueOf())
        )
      )
  }

  const handleInputChange = (e) => {
    const value = e.target.value
    setEmailAddress(value)
  }
  const handleReset = () => {
    form.resetFields()
  }
  const handleOk = () => {
    Modal.destroyAll()
    form.resetFields()
  }

  return (
        <Button
            size='middle'
            className={styles.button}
            onClick={() => userInvitationDialog(
              onSubmit,
              form,
              handleReset,
              inputField,
              handleInputChange,
              emailAddress
            )}
        >
            Add new user
            <IconUserAddPlus size={'sm'} />
        </Button>
  )
}

export default AddNewUser
